module.exports = __webpack_public_path__ + "img/next_arrow.326deff1.svg";